import type {
  CentralLeadDetailSection,
  CentralLeadDisplayField,
  CentralLeadInsightCard,
} from "./types.ts";

export function CentralLeadFieldGrid({ fields }: { fields: CentralLeadDisplayField[] }) {
  if (!fields.length) return null;
  return (
    <div className="central-lead-grid">
      {fields.map((field) => (
        <div className="central-lead-cell" key={`${field.key}-${field.value}`}>
          <span className="central-lead-label">{field.label}</span>
          <span className="central-lead-value" title={field.value}>{field.value}</span>
        </div>
      ))}
    </div>
  );
}

export function CentralLeadInsightCards({ cards }: { cards: CentralLeadInsightCard[] }) {
  if (!cards.length) return null;
  return (
    <div className="central-lead-insights">
      {cards.map((card) => (
        <div className={`central-lead-insight ${card.tone ? `tone-${card.tone}` : ""}`} key={card.key}>
          <span className="central-lead-insight-label">{card.label}</span>
          <strong className="central-lead-insight-value" title={card.value}>{card.value}</strong>
          {card.detail ? <span className="central-lead-insight-detail" title={card.detail}>{card.detail}</span> : null}
        </div>
      ))}
    </div>
  );
}

export function CentralLeadDetailSections({
  qualificationFields,
  detailSections,
  hiddenSensitiveCount,
}: {
  qualificationFields: CentralLeadDisplayField[];
  detailSections: CentralLeadDetailSection[];
  hiddenSensitiveCount: number;
}) {
  if (!qualificationFields.length && !detailSections.length && !hiddenSensitiveCount) return null;
  return (
    <div className="central-lead-expanded">
      {qualificationFields.length ? (
        <section className="central-lead-section">
          <h4 className="central-lead-section-title">Qualificacao e marketing</h4>
          <CentralLeadFieldGrid fields={qualificationFields} />
        </section>
      ) : null}

      {detailSections.map((section) => (
        <details className="central-lead-details" key={section.key}>
          <summary>
            <span>{section.title}</span>
            <small>{section.count} item{section.count === 1 ? "" : "s"}</small>
          </summary>
          <CentralLeadFieldGrid fields={section.fields} />
        </details>
      ))}

      {hiddenSensitiveCount ? (
        <div className="central-lead-sensitive-note">
          Dados pessoais sensiveis ocultos nesta visualizacao.
        </div>
      ) : null}
    </div>
  );
}
